import { render, staticRenderFns } from "./marketCodeCat.vue?vue&type=template&id=96ae3a96&"
import script from "./marketCodeCat.vue?vue&type=script&lang=js&"
export * from "./marketCodeCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports